import * as React from 'react';
import { observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';

// Types
export type IFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  role: string;
};

// Utilities
import {
  required,
  email,
  name,
  mobile,
  between
} from '../../utilities/validation';

// Form
class DetailsFormState {
  // Create a field
  firstName = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(2, 50), name);
  lastName = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(2, 50), name);
  email = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(5, 100), email);
  mobile = new FieldState('')
    .disableAutoValidation()
    .validators(required, mobile);
  role = new FieldState('USER').disableAutoValidation().validators(required);

  // Compose fields into a form
  state = new FormState({
    firstName: this.firstName,
    lastName: this.lastName,
    email: this.email,
    mobile: this.mobile,
    role: this.role
  });

  getValues() {
    return {
      firstName: this.firstName.$,
      lastName: this.lastName.$,
      email: this.email.$,
      mobile: this.mobile.$,
      role: this.role.$
    };
  }

  initValues(values: IFormValues) {
    this.firstName.reinitValue(values.firstName);
    this.lastName.reinitValue(values.lastName);
    this.email.reinitValue(values.email);
    this.mobile.reinitValue(values.mobile);
    this.role.reinitValue(values.role);
  }

  reset() {
    this.firstName.reinitValue('');
    this.lastName.reinitValue('');
    this.email.reinitValue('');
    this.mobile.reinitValue('');
    this.role.reinitValue('');
  }
}

// Components
import Box from '../../components/Box';
import Button from '../../components/Button';
import Grid from '../../components/Grid';
import { Form, TextField, Select } from '../../components/FormStateFields';

// Component
interface IProps {
  values: IFormValues;
  onSubmit: (values: IFormValues) => void;
  onDelete: () => void;
}

class MemberDialogDetails extends React.Component<IProps, {}> {
  form = new DetailsFormState();

  componentDidMount() {
    this.form.initValues(this.props.values);
  }

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const validation = await this.form.state.validate();

    if (validation.hasError === false) {
      this.props.onSubmit({ ...this.props.values, ...this.form.getValues() });
    }
  };

  render() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <Box pa={4}>
          <Grid container={true}>
            <Grid item={true} xs={6}>
              <TextField
                label="First Name"
                type="text"
                required={true}
                fieldState={this.form.firstName}
                margin="normal"
                fullWidth={true}
                disabled={true}
              />
            </Grid>
            <Grid item={true} xs={6}>
              <TextField
                label="Last Name"
                type="text"
                required={true}
                fieldState={this.form.lastName}
                margin="normal"
                fullWidth={true}
                disabled={true}
              />
            </Grid>
          </Grid>
          <TextField
            label="Email"
            type="text"
            required={true}
            fieldState={this.form.email}
            margin="normal"
            fullWidth={true}
          />
          <TextField
            label="Mobile No."
            type="text"
            required={true}
            fieldState={this.form.mobile}
            margin="normal"
            fullWidth={true}
          />

          <Select
            label={'Privacy'}
            fieldState={this.form.role}
            options={[
              { value: 'USER', label: 'User' },
              { value: 'ADMIN', label: 'Admin' }
            ]}
            margin={'normal'}
            fullWidth={true}
          />
          <br />
          <br />
          <Grid container={true}>
            <Grid item={true} xs={3}>
              <Button
                raised={true}
                color="secondary"
                style={{ width: '100%' }}
                onClick={this.props.onDelete}
              >
                Delete
              </Button>
            </Grid>
            <Grid item={true} xs={9}>
              <Button
                raised={true}
                color="primary"
                style={{ width: '100%' }}
                type="submit"
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Form>
    );
  }
}

export default observer(MemberDialogDetails);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/UserDialogDetailsEdit.tsx